import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { PlanPicker2024Component } from '../../shared/plan-picker/2024/plan-picker-2024.component';
import { ProductOrderDowngradeGuard } from './guards/product-order-downgrade.guard';
import { migrationGuard } from './guards/product-order-migration.guard';
import { ProductOrderParamsGuard } from './guards/product-order-params.guard';
import { ProductOrderPaymentStepGuard } from './guards/product-order-payment-step.guard';
import { ProductOrderBillingStepComponent } from './product-order-billing-step/product-order-billing-step.component';
import { DowngradeView2024Texts } from './product-order-downgrade-step/downgrade-view-2024-texts';
import { ProductOrderDowngradeStepComponent } from './product-order-downgrade-step/product-order-downgrade-step.component';
import { DowngradeTextsToken } from './product-order-downgrade-step/product-order-downgrade.types';
import { ProductOrderMigrationStepComponent } from './product-order-migration-step/product-order-migration-step.component';
import { ProductOrderParameterizedComponent } from './product-order-parameterized/product-order-parameterized.component';
import { ProductOrderPaymentStepComponent } from './product-order-payment-step/product-order-payment-step.component';
import { ProductOrderDefaultStep, ProductOrderStepUrl } from './product-order.types';
import { ProductOrderComponent } from './product-order/product-order.component';

export const ROUTES: Route[] = [
  {
    path: '',
    component: ProductOrderComponent,
    children: [
      {
        path: ProductOrderStepUrl.ProductPicker,
        component: PlanPicker2024Component,
      },
      {
        path: ':productId/:quantity/:interval',
        component: ProductOrderParameterizedComponent,
        canActivate: [ProductOrderParamsGuard],
        canActivateChild: [ProductOrderDowngradeGuard],
        providers: [
          {
            provide: DowngradeTextsToken,
            useValue: DowngradeView2024Texts,
          },
        ],
        children: [
          {
            path: ProductOrderStepUrl.Downgrade,
            component: ProductOrderDowngradeStepComponent,
          },
          {
            path: ProductOrderStepUrl.Migration,
            component: ProductOrderMigrationStepComponent,
          },
          {
            path: ProductOrderStepUrl.OrderBilling,
            component: ProductOrderBillingStepComponent,
            canActivate: [migrationGuard],
          },
          {
            path: ProductOrderStepUrl.OrderPayment,
            canActivate: [ProductOrderPaymentStepGuard],
            component: ProductOrderPaymentStepComponent,
          },
        ],
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ProductOrderDefaultStep,
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
})
export class ProductOrder2024RoutingModule {}
